// frontend/src/utils/number.js
// 천단위 콤마 유틸 — 금액·면적 등 숫자 입력/표시 공용.
//   · 소수점 유지(정수부만 콤마), 음수·입력중 상태('-', '.', '12.') 대응
//   · 상태에는 콤마 없이 저장하고 화면에만 콤마를 씌우는 용도

export function commaView(v) {
  if (v === null || v === undefined) return "";
  let s = String(v).replace(/,/g, "");
  if (s === "" || s === "-" || s === "." || s === "-.") return s;
  const neg = s[0] === "-" ? "-" : "";
  if (neg) s = s.slice(1);
  const dot = s.indexOf(".");
  let intp = dot >= 0 ? s.slice(0, dot) : s;
  const dec = dot >= 0 ? s.slice(dot) : "";
  if (!/^\d*$/.test(intp)) return neg + s + dec;
  intp = intp.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return neg + intp + dec;
}

export function stripComma(v) {
  return String(v ?? "").replace(/,/g, "");
}
